var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',[_c('div',{staticClass:"transition-swing",class:["text-h4"],domProps:{"textContent":_vm._s(_vm.title)}}),_c('v-subheader',[_vm._v(_vm._s(_vm.subheader))])],1),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }